// src/components/ContentCard/DeleteDialog.js
import React from 'react';
import ConfirmationDialog from '../../../../components/dialog/ConfirmationDialog';

const DeleteDialog = ({ open, title, onCancel, onConfirm, itemName }) => (
  <ConfirmationDialog
    open={open}
    title="Delete Reading Practice Content"
    message="Are you sure you want to delete {itemName}? This action cannot be undone."
    itemName={title}
    onCancel={onCancel}
    onConfirm={onConfirm}
    confirmText="Delete"
    destructive={true}
  />
);

export default DeleteDialog;